<button *ngIf="canPreview()" mat-icon-button
        matTooltip="Apercu fichier"
        (click)="popUpPreviewImage()">
  <mat-icon color="accent">zoom_in
  </mat-icon>
</button>
